/**
 * TKP-27 / 6.4c-1 — "kullanıldığı yerler" panel satırı düğümdür (süreç×veri): kaynaklar `datasources[]` (K1).
 * Eski satırın tekil `datasource` alanı artık yok; kaynak sütunu adların birleşimidir.
 */
export const sourceNamesOf = (row, translate) =>
  (row && Array.isArray(row.datasources) ? row.datasources : [])
    .filter(Boolean)
    .map((d) => translate(d.name))
    .join(", ");

/** Sayfadan bir satırı düşer (kuyruklu silme sonrası); sayfa şekli ve toplam korunur. */
export const withoutInfoRow = (info, relId) => {
  if (!info || !Array.isArray(info.docs)) return info;
  const docs = info.docs.filter((r) => String(r.rel_id) !== String(relId));
  return { ...info, docs, totalDocs: Math.max(0, (info.totalDocs || 0) - (info.docs.length - docs.length)) };
};

/**
 * Düğüm listesinden tekil veri seçenekleri (hukuki metin filtresi, 6.4c-1). Kategori seçiliyse düğümün EFEKTİF kategorisine
 * göre (K4: override ya da verinin kategorisi). Seçenek organizasyon verisidir (`_id` veri id'si).
 */
export const datasOfNodes = (nodes, categories) => {
  const allowed = Array.isArray(categories) && categories.length > 0 ? new Set(categories.map((c) => String(c._id))) : null;
  const seen = new Map();
  for (const n of nodes || []) {
    if (!n || !n.data || !n.data._id) continue;
    const category = n.effectiveCategory || n.category || n.data.category;
    if (allowed && !(category && allowed.has(String(category._id || category)))) continue;
    if (!seen.has(String(n.data._id))) seen.set(String(n.data._id), { _id: n.data._id, name: n.data.name });
  }
  return [...seen.values()];
};
